import client from "../api-client";

const URL = "/nodes.php";

export const get = () => {
  return client(URL);
};
